export default __webpack_public_path__ + "static/media/chess-dark-brown-light-pieces(reduced).e155dff1.webp";